<form [formGroup]="loginForm" (ngSubmit)="login()">
  <div class="login-Wrapper">
    <div class="login login-select">
      <h2 class="title-3 text-center">
        {{ "Login" | translate }}
      </h2>

      <!--      <div class="form-group is-havingIcon">-->
      <!--        <input type="email"-->
      <!--               class="form-control"-->
      <!--               [ngClass]="{ 'is-invalid': usernameError}"-->
      <!--               placeholder="{{ 'Username' | translate }}"-->
      <!--               formControlName="username"-->
      <!--               id="username"/>-->
      <!--        <i class="fas fa-envelope form-icon" parent-class="is-havingIcon"></i>-->
      <!--        <app-error-input message="Test Message"></app-error-input>-->
      <!--      </div>-->
      <div class="form-group is-havingIcon">
        <app-evento-input
          [eventoFormControl]="loginForm.get('mobile')"
          type="mobile"
          placeholder="{{ 'Mobile number' | translate }}"
          requiredMessage="{{ 'Required Field' | translate }}"
          validatePhoneNumberMessage="{{ 'Valid Mobile Number' | translate }}"
        ></app-evento-input>

        <!-- <app-evento-input
          [eventoFormControl]="loginForm.get('username')"
          requiredMessage="{{ 'Required Field' | translate }}"
          placeholder="{{ 'Username' | translate }}"
          icon="fas fa-envelope form-icon"
        ></app-evento-input> -->
      </div>

      <div class="form-group is-havingIcon">
        <app-evento-input
          type="password"
          [eventoFormControl]="loginForm.get('password')"
          requiredMessage="{{ 'Required Field' | translate }}"
          minlengthMessage="{{
            'Min Length Field' | translate : { value: '6' }
          }}"
          placeholder="{{ 'Password' | translate }}"
          icon="fas fa-unlock-alt form-icon"
        ></app-evento-input>
      </div>

      <button
        type="submit"
        [disabled]="loginForm.invalid"
        class="btn btn-primary w-100 mb-3"
      >
        {{ "Login" | translate }}
      </button>

      <div class="flex justify-between">
        <a [routerLink]="['/auth/activate']" class="login-forgetPassLink">
          {{ "Activate Account" | translate }}
        </a>
        <a [routerLink]="['/auth/reset']" class="login-forgetPassLink">
          {{ "did you forget your password?" | translate }}
        </a>
      </div>

      <div class="login-social"></div>

      <p class="login-noAccountLink">
        {{ "Don't have an account yet?" | translate }}
      </p>
      <a [routerLink]="['../signup-type']" class="btn btn-warning w-100 mb-5">
        {{ "Register now" | translate }}
      </a>
    </div>
  </div>
</form>
